import './SearchForm.css';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Alert, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import FormContent from '../../components/Form/FormContent';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Spinner from '../../components/Common/Spinner/Spinner';
import Layout from '../Layout';

import es from '../../lang/es';

import { getJurisdictionAction } from '../../actions/proceedingActions';

const SearchForm = () => {
    const params = useParams();
    const dispatch = useDispatch();

    const { jurisdiction } = params;

    const selectedJurisdiction = useSelector( state => state.proceeding.selectedJurisdiction );
    const loadingProceedings = useSelector( state => state.proceeding.loading );

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadJurisdiction();
    }, []);
    
    const loadJurisdiction = () => {
        //Verifico si está cargado
        if(!selectedJurisdiction){
            //Llamo al dispatch
            dispatch( getJurisdictionAction(jurisdiction) );
        }
    }
    
    //Render
    return (
        <Spinner active={loadingProceedings || loading}>
            <GoogleReCaptchaProvider 
                reCaptchaKey={ process.env.REACT_APP_RECAPTCHA_KEY }
            >
                {
                    selectedJurisdiction ? (
                        <Layout 
                            title={selectedJurisdiction.description} 
                            subtitle={es.SEARCH_FORM}
                            items={[
                                {
                                    title: `${selectedJurisdiction.description} - ${es.SEARCH_FORM}`,
                                    active: true
                                }
                            ]}
                        >
                            <Col xs={12}>
                                <Alert variant="info">
                                    Complete alguno de los parámetros (<strong>No. Expt, Actor y/o Demandado</strong>) para realizar la búsqueda. 
                                    Opcionalmente puede filtrar por una <strong>Unidad Judicial</strong>. 
                                    Luego presione el botón <FontAwesomeIcon icon={ faSearch } /> para ejecutar la búsqueda.
                                </Alert>
                            </Col>
                            <FormContent 
                                jurisdiction={selectedJurisdiction}
                                setLoading={setLoading} 
                            />
                        </Layout>
                    ) : null
                }
            </GoogleReCaptchaProvider>
        </Spinner>
    );
};

export default SearchForm;